import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 93BBA1EA-76F8-4D2E-B4D0-98F684B15AC3
 * name plus-circle-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-circle-multiple.svg
 * tags
 */
export const PlusCircleMultipleIcon = createSvgIcon(<><path d="M2 12C2 9.2 3.6 6.8 6 5.7V3.5C2.5 4.8 0 8.1 0 12S2.5 19.2 6 20.5V18.3C3.6 17.2 2 14.8 2 12M15 3C10 3 6 7 6 12S10 21 15 21 24 17 24 12 20 3 15 3M20 13H16V17H14V13H10V11H14V7H16V11H20V13Z" /></>, 'PlusCircleMultipleIcon');
export default PlusCircleMultipleIcon